import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';
import { ConcluData } from '../consts/Data.js';

export default class ConcluItem extends Phaser.GameObjects.Container {
    constructor(scene, x, index) {
        super(scene, x, 644, []);
        scene.add.existing(this);
        this.scene = scene;
        this.itemData = ConcluData.screen4.items[index]
        this.isClicked = false;
        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });

        this.background = this.scene.add.rexRoundRectangle(0, 0, 390, 442, 20, Colors.Elmt.lightBlue).setOrigin(0.5);
        this.backgroundBorder = this.scene.add.rexRoundRectangle(-10, -10, 390, 442, 20, Colors.Elmt.Black, 0).setOrigin(0.5);
        this.backgroundBorder.setStrokeStyle(4, Colors.Elmt.Black);
        this.add(this.background);
        this.add(this.backgroundBorder);

        this.title = this.scene.createTextElement(0, -160, this.itemData.title).setOrigin(0.5);
        this.add(this.title);
        this.illu = this.scene.add.image(0, 40, this.itemData.illu).setOrigin(0.5);
        this.add(this.illu);

        this.txt = this.scene.createTextElement(0, this.title.y + 60, this.itemData.content).setOrigin(0.5, 0).setAlpha(0)
        this.add(this.txt);
        this.setSize(this.background.width, this.background.height);
        this.setInteractive({ useHandCursor: true });

        this.on('pointerdown', () => {
            this.clickSound.play();
            this.background.setFillStyle(Colors.Elmt.MidOrange);
            // this.illu.setAlpha(0);
            // this.txt.setAlpha(1);
            this.scene.tweens.add({
                targets: this.illu,
                alpha: 0,
                duration: 100,
                onComplete: () => {
                    this.scene.tweens.add({
                        targets: this.txt,
                        alpha: 1,
                        duration: 100,
                        delay: 100,
                        onComplete: () => {
                        }

                    })
                }

            })
            this.isClicked = true;
            if (this.scene.items.every(item => item.isClicked)) {
                this.scene.nextBtn.setUnlocked()
            }
        })

    }

    setLocked() {
        this.txt.setAlpha(0.5);
        this.state = 'locked';
        this.disableInteractive();
    }

    setUnlocked() {
        this.isLock = false;
        this.txt.setAlpha(0.5);
        this.state = 'unlocked';
        this.setSize(this.txt.width, this.txt.height);
        this.setInteractive({ useHandCursor: true });
        // this.input.hitArea.setTo(this.w / 2 - 14, this.h / 2 - 14, this.w + 14, this.h + 14);
    }

    setClickFunction(clickFunction) {
        this.on('pointerup', () => {
            clickFunction(this);
        }, this.scene);
    }

    setActif() {
        this.isLock = false;
        this.state = 'actif';
        this.txt.setAlpha(1);
        this.isDone = true;
    }

    suppress() {
        // Retirer tous les listeners d'événements
        this.removeAllListeners();

        // Détruire les éléments enfants uniquement s'ils existent encore
        if (this.background && this.background.scene) this.background.destroy();
        if (this.backgroundBorder && this.backgroundBorder.scene) this.backgroundBorder.destroy();
        if (this.title && this.title.scene) this.title.destroy();
        if (this.illu && this.illu.scene) this.illu.destroy();
        if (this.txt && this.txt.scene) this.txt.destroy();

        // Détruire le container
        this.destroy();
    }
}